/* eslint-disable import/no-anonymous-default-export */
export default {
    serviceId: 'service_x7ymjum',
    templateId: 'template_odmfo8o',
    userId: 'tbvmJbxEOrRFknglu'
};